import React, { useEffect } from "react";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";

import CheckMarkSuccessful from "../../../images/checkmark_successful.svg";
import DefaultOnboardingStatusPage from "../../ReusablePages/DefaultOnboardingStatusPage/DefaultOnboardingStatusPage";
import {
  getCurrentUrl,
  registerIdentityEvent,
  registerTrackingEvent,
} from "../../../utils/helpers";
import { getStoredAuthProvider } from "../../../utils/storage";
import {
  OnboardingSteps,
  ROUTES,
  TRACKING_EVENTS,
} from "../../../utils/constants";
import useAuth from "../../../hooks/useAuth";

const redirectPath = ROUTES.ROOT.SIGN_UP;

function SignUpSuccessfulPage() {
  const { userProfile } = useAuth();
  const authProvider = getStoredAuthProvider();

  useEffect(() => {
    if (!userProfile || !authProvider) return;
    const { id, email, firstName, lastName, username } = userProfile;
    registerTrackingEvent({
      name: TRACKING_EVENTS.SUCCESSFUL_WEB_SIGNUP,
      payload: {
        user_id: id,
        email: email,
        url: getCurrentUrl(),
      },
    });
    registerTrackingEvent({
      name:
        authProvider === OAuthProvider.GOOGLE
          ? TRACKING_EVENTS.WEB_SIGN_UP_WITH_GOOGLE
          : TRACKING_EVENTS.WEB_SIGN_UP_WITH_FACEBOOK,
      payload: {
        user_id: id,
        email: email,
        url: getCurrentUrl(),
      },
    });

    registerIdentityEvent(id, {
      name: `${firstName} ${lastName}`,
      email: email,
      username: username,
    });
  }, [authProvider, userProfile]);

  return (
    <DefaultOnboardingStatusPage
      titleText="Sign up successful"
      secondaryText="You have successfully signed up to Hyper!"
      primaryImage={CheckMarkSuccessful}
      redirectDelay={3000}
      redirectPath={redirectPath}
      nextStep={OnboardingSteps.USE_REFERRAL_CODE}
    />
  );
}

export default SignUpSuccessfulPage;
